var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestdriveconfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 687,
    height: 509,
    viewBox: "0 0 687 509",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_3398)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M645.401 292.39H648.321V288.15H604.601V256.86H541.611V326.19H503.601V259H474.261L444.921 274.67V307.89H412.681V248.8H354.011V399.47H314.881V418.49H686.371V411.47H645.381V292.41L645.401 292.39Z",
    fill: "#E6E9F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.939 290.4H563.089V299.54H553.939V290.4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.141 290.4H592.281V299.54H583.141V290.4Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.141 271.95H592.281V281.09H583.141V271.95Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M633.111 322.52H623.971V331.66H633.111V322.52Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M633.111 304.06H623.971V313.21H633.111V304.06Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.141 336.33H592.281V345.48H583.141V336.33Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.43 359.67C650.94 359.26 651.17 361.3 651.14 362.09C650.1 360.67 648.23 364.44 649.05 366.65C646.31 366.07 645.34 368.8 646.1 373.7C643.67 372.11 642.45 375.33 643.27 378.3C639.71 378.23 642.19 382.61 641.21 384.71C639.79 387.75 638.26 393.07 641.1 396.44C636.12 395.3 638.08 398.32 639.57 401.51C639.52 401.69 632.47 399.58 638.66 411.13C635.83 410.74 635.87 414.6 636.95 418.48H665.64C669.6 415 675.9 401.39 669.9 402.34C672.01 398.69 670.86 394.53 668.57 395.98C671.49 389.79 670.73 386.32 665.63 387.69C666.84 387.03 668.97 382.12 665.91 381.69C667.38 379.14 666.25 377.55 664.04 378.18C663.98 376.48 664.38 370.76 661.77 371.48C659.36 372.15 662.88 367.5 660.46 366.89C660.75 364.96 659.67 364.59 658.96 365C658.62 360.43 656.98 360.23 655.94 361.38C655.78 360.77 655.74 360.06 655.68 359.39C655.43 356.36 653.47 354.89 652.66 358.83C652.57 359.28 652.56 359.63 652.43 359.67ZM666.46 418.48C666.22 418.4 665.95 418.4 665.65 418.48H666.46Z",
    fill: "#E6E9F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.02 411.46H0V418.48H243.23V411.46V327.27H117.17V294.26H50.72V324.73H32.53L10.02 341.26V411.46Z",
    fill: "#E6E9F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.599 210.61C511.879 210.61 548.159 210.61 584.449 210.61C583.999 201.45 577.999 194.68 569.259 196.99C569.509 195.82 569.639 194.61 569.639 193.36C569.639 183.83 561.919 176.11 552.389 176.11C546.579 176.11 541.449 178.98 538.319 183.37C535.329 180.02 530.969 177.91 526.119 177.91C521.999 177.91 518.239 179.43 515.369 181.94C512.499 179.43 508.729 177.91 504.619 177.91C496.879 177.91 490.389 183.29 488.699 190.52C479.029 191.91 473.059 199.71 475.599 210.61Z",
    fill: "#E6E9F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.079 131.36H0.619141C1.09914 121.64 7.45914 114.46 16.7291 116.91C16.4591 115.67 16.3191 114.38 16.3191 113.06C16.3191 102.95 24.5091 94.76 34.6191 94.76C40.7791 94.76 46.2291 97.8 49.5391 102.47C52.7191 98.91 57.3391 96.68 62.4791 96.68C66.8491 96.68 70.8291 98.29 73.8791 100.96C76.9291 98.3 80.9191 96.68 85.2791 96.68C93.4891 96.68 100.369 102.39 102.169 110.06C112.419 111.53 118.759 119.81 116.059 131.37L116.079 131.36Z",
    fill: "#E6E9F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.829 17.38H375.739C390.289 17.38 402.199 29.29 402.199 43.84V417.23C402.199 431.78 390.289 443.69 375.739 443.69H218.829C204.279 443.69 192.369 431.78 192.369 417.23V43.84C192.369 29.29 204.279 17.38 218.829 17.38Z",
    fill: "#213B3F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.339 28.2C350.269 35.45 343.989 41.06 336.459 41.06H258.109C250.569 41.06 244.289 35.45 243.229 28.2H218.829C210.249 28.2 203.189 35.26 203.189 43.84V417.23C203.189 425.81 210.249 432.87 218.829 432.87H375.739C384.319 432.87 391.379 425.81 391.379 417.23V43.84C391.379 35.26 384.319 28.2 375.739 28.2H351.339Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_191_3398",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 203,
    y: 28,
    width: 189,
    height: 405
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M351.339 28.2C350.269 35.45 343.989 41.06 336.459 41.06H258.109C250.569 41.06 244.289 35.45 243.229 28.2H218.829C210.249 28.2 203.189 35.26 203.189 43.84V417.23C203.189 425.81 210.249 432.87 218.829 432.87H375.739C384.319 432.87 391.379 425.81 391.379 417.23V43.84C391.379 35.26 384.319 28.2 375.739 28.2H351.339Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_191_3398)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.961 238.9V198.22H326.141V238.9H357.961Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.961 265.97V303.05H321.391V265.97H357.961Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.68 433.11V392.73H382.52V433.11H277.68Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.08 467.51V399.15L224.18 426.61V467.5H263.08V467.51ZM229.88 389.48H224.17V393.51L229.88 389.48Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.051 330.71V307.6H357.961V330.71H393.741V371.1H339.351V365.84H326.051V330.71Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.74 107.02V146.81H358.82V107.02H393.74Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.271 146.81V107.02H317.791L332.451 146.81H354.271Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.08 282.67V226.98H277.07V282.67H299.08Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.08 198.99H277.07V222.43H299.08V198.99Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.08 178.69H326.14V306.98H299.08V178.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.66 342.34H218.6V413.2V397.44L296.66 342.34Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.16 309.65H198.66V337.78H299.16V309.65Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.09 294.76H198.66V322.9H275.11L250.09 294.76Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.09 176.48H226.65V224.76H250.09V176.48Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.65 146.48H303.69L313.06 171.93H270.65V146.48Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.65 107.02H289.15L302.01 141.93H242.65V107.02Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.65 370.88H285.54V491.9H258.65V370.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.09 146.48H242.65V171.92H266.09V146.48Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.1 107.02H198.66V171.92H238.1V107.02Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.1 176.48H198.66V224.76H222.1V176.48Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.66 251.83V271.12H224.17V290.41H250.09V251.83H198.66Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.24 240.72H172.79C168.95 240.72 165.46 239.15 162.93 236.62C160.4 234.09 158.83 230.6 158.83 226.76V207.67H165.6V226.76C165.6 228.73 166.41 230.53 167.71 231.84C169.01 233.14 170.81 233.95 172.79 233.95H260.24V240.72Z",
    fill: "#D6DAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.23 188.84H315.99V310.18H309.23V188.84Z",
    fill: "#D6DAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.229 345.89V354.16C270.549 381.46 231.879 408.76 193.199 436.07V427.8L309.229 345.89Z",
    fill: "#D6DAE6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.051 393.77V342.34H188.131V393.77H214.051Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.741 151.37H362.511H342.311V193.66H362.511V238.52H393.741V151.37Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.74 281.2V326.16H362.51V265.97L393.74 281.2Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.99 254.86H436.48C440.32 254.86 443.81 253.29 446.34 250.76C448.87 248.23 450.44 244.74 450.44 240.9V221.81H443.67V240.9C443.67 242.87 442.86 244.67 441.56 245.98C440.26 247.28 438.46 248.09 436.48 248.09H315.99V254.86Z",
    fill: "#D6DAE6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.491 79.57V56.23H229.381V79.57H268.491Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.52 375.9H426.87V382.67H359.52V375.9Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.52 107.02H312.51C318.91 107.02 325.02 104.48 329.55 99.95C334.07 95.43 336.62 89.32 336.62 82.91V59.94H309.55V79.95H194.52V107.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.711 374.94H275.481V498.91H268.711V374.94Z",
    fill: "#D6DAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.029 401.64H354.579V413.19H350.029V401.64Z",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 22.93
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.87 427.64H387.07V392.73H426.87V427.64Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.521 451.63V400.2H340.221V451.63H382.521Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.18 451.63H382.52V420.4H309.18V451.63Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.321 47.08H369.881V79.34H393.321V47.08Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.331 50.37H341.891V79.34H365.331V50.37Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.87 498.91H387.07V432.2H426.87V498.91Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.051 79.35H309.141L337.271 44.43H273.051V79.35Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.821 60.13H229.381V34.69H252.821V60.13Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.831 79.57H185.381V14.66H224.831V79.57Z",
    fill: "#E6E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.369 90.23L373.069 0L394.109 17L330.639 95.78H301.959L300.369 90.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.23 306.69C309.23 304.72 308.42 302.92 307.12 301.62C305.82 300.32 304.02 299.51 302.05 299.51H274.21C270.37 299.51 266.88 297.94 264.35 295.41C261.82 292.88 260.25 289.39 260.25 285.55V196.04C260.25 192.2 261.82 188.71 264.35 186.18C266.88 183.65 270.37 182.08 274.21 182.08H317.91C322.23 182.08 324.09 180.91 324.58 179.22C325.24 176.91 324.35 173.45 323.11 170.07L299.89 107.03H307.09L329.45 167.75C331.11 172.25 332.23 177.08 331.08 181.08C329.76 185.69 325.98 188.86 317.91 188.86H274.21C272.24 188.86 270.44 189.67 269.13 190.97C267.83 192.27 267.02 194.07 267.02 196.05V285.56C267.02 287.53 267.83 289.33 269.13 290.63C270.43 291.93 272.23 292.74 274.2 292.74H302.04C305.88 292.74 309.37 294.31 311.9 296.84C314.43 299.37 316 302.86 316 306.7V368.72C316 370.69 316.81 372.49 318.11 373.79C319.41 375.09 321.21 375.9 323.18 375.9H350.81V382.67H323.18C319.34 382.67 315.85 381.1 313.32 378.57C310.79 376.04 309.22 372.55 309.22 368.71V306.69H309.23Z",
    fill: "#D6DAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.52 89.15H403.26V95.91H194.52V89.15Z",
    fill: "#D6DAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.09 12.43L378.35 20.38L317.74 95.78H309.08L376.09 12.43Z",
    fill: "#D6DAE6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.611 162.92C316.381 162.92 319.431 165.98 319.431 169.74C319.431 173.5 316.371 176.56 312.611 176.56C308.851 176.56 305.791 173.51 305.791 169.74C305.791 165.97 308.851 162.92 312.611 162.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.61 201.11C323.12 201.11 331.64 209.63 331.64 220.14C331.64 230.65 323.12 239.17 312.61 239.17C302.1 239.17 293.58 230.65 293.58 220.14C293.58 209.63 302.1 201.11 312.61 201.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.611 207.08C319.821 207.08 325.671 212.93 325.671 220.14C325.671 227.35 319.821 233.2 312.611 233.2C305.401 233.2 299.551 227.35 299.551 220.14C299.551 212.93 305.401 207.08 312.611 207.08Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.61 215.45C315.2 215.45 317.3 217.55 317.3 220.14C317.3 222.73 315.2 224.83 312.61 224.83C310.02 224.83 307.92 222.73 307.92 220.14C307.92 217.55 310.02 215.45 312.61 215.45Z",
    fill: "white"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6908 508.88H92.4708C94.5708 502.56 100.571 480.46 105.701 453.98C108.331 471.27 110.281 488.92 110.931 508.88H162.971C165.161 482.28 169.331 377.67 160.261 361.35C158.631 358.42 132.961 365.16 113.631 370.72V370.54C63.9208 359.27 33.9408 352.93 32.5508 369.11C29.2908 407.15 39.5908 462.87 37.6908 508.88Z",
    fill: "#213B3F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6195 175.92C33.4295 179.66 35.6295 247.28 34.6795 304.19C34.1895 333.63 28.2995 352.56 31.9295 382.88C57.6695 384.37 101.7 404.16 164.03 374.04C165.33 357.94 161.1 320.17 160.86 307.45C160.47 286.9 168.63 258.53 165.19 232.81C159.78 192.37 148.92 182.62 123.76 172.79C78.6995 167.53 86.7395 160.9 42.6095 175.92H42.6195Z",
    fill: "#295860"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.3 203.17H219.2C219.8 203.17 220.22 203.34 220.44 203.64L223.29 206.67C223.89 207.18 223.7 208.25 222.65 209.47L189.57 248.26C188.1 249.98 185.5 251.38 183.78 251.38H161.88C161.28 251.38 160.86 251.21 160.64 250.91C160.59 250.86 160.54 250.81 160.5 250.76C160.45 250.71 160.4 250.66 160.36 250.61C160.31 250.56 160.26 250.51 160.22 250.46C160.17 250.41 160.12 250.36 160.08 250.31C160.03 250.26 159.98 250.21 159.94 250.16C159.89 250.11 159.84 250.06 159.8 250.01C159.75 249.96 159.7 249.91 159.66 249.86C159.61 249.81 159.56 249.76 159.52 249.71C159.47 249.66 159.42 249.61 159.38 249.56C159.33 249.51 159.28 249.46 159.24 249.41C159.19 249.36 159.14 249.31 159.1 249.26C159.05 249.21 159 249.16 158.96 249.11C158.91 249.06 158.86 249.01 158.82 248.96C158.77 248.91 158.72 248.86 158.68 248.81C158.63 248.76 158.58 248.71 158.54 248.66C158.49 248.61 158.44 248.56 158.4 248.51C158.35 248.46 158.3 248.41 158.26 248.36C158.21 248.31 158.16 248.26 158.12 248.21C158.07 248.16 158.02 248.11 157.98 248.06C157.93 248.01 157.88 247.96 157.84 247.91C157.24 247.4 157.43 246.33 158.48 245.1L191.56 206.31C193.03 204.59 195.63 203.19 197.35 203.19L197.3 203.17Z",
    fill: "#213B3F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.19 310.67C168.29 311.74 172.31 313.28 176.1 311.9C181.56 309.92 185.92 306.51 189.47 299.56C192.56 293.51 199.96 273.29 192.55 268.57C189.81 266.83 171.38 258.41 163.42 267.92C156.3 276.42 154.54 296.57 161.01 305.68C162.74 308.12 163.58 309.34 166.2 310.67H166.19Z",
    fill: "#295860"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 273.25C156.79 281.64 155.82 297.05 161.38 304.87C171.23 316.89 183.64 307.88 187.79 297.8C189.64 294.17 193.69 286.58 194.42 279.25C194.85 274.88 194.34 271.11 191.92 269.57L192.86 268.19C196.2 270.32 197.07 274.66 196.55 279.86C195.3 292.47 189.43 308.34 176.51 313.02C173.47 314.12 170.47 313.86 167.75 312.74C164.66 311.47 161.97 309.08 160.04 306.37C153.98 297.84 155.12 281.85 159.18 272.67L160.5 273.25Z",
    fill: "#295860"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1005 279.94C78.3305 275.47 102.21 267.09 117.31 262.66C121.27 271.43 124.73 279.11 128.68 287.89C112.94 300.3 46.1205 334.55 28.1105 323.27L28.0705 323.24C7.38048 310.13 15.7105 213.85 24.7605 194.06C28.7505 185.34 33.8205 180.03 42.6105 175.91C63.5205 166.12 61.7105 261.92 62.0905 279.94H62.1005Z",
    fill: "#295860"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.47 264.84L169.18 269.93C169.18 269.93 171.5 280.26 177.47 280.84C185.66 281.64 191.01 274.53 190.6 267.04C190.6 267.04 177.19 263.16 170.48 264.84H170.47Z",
    fill: "#FCC8A0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.291 258.59C194.951 261.79 195.721 264.3 195.091 265.05C193.661 266.75 192.431 269.69 189.221 271.32C186.011 272.96 178.581 275.82 174.151 271.39C169.721 266.96 170.131 261.71 170.131 261.71C170.131 261.71 169.141 253.27 175.431 249.1C181.721 244.93 198.991 247.27 198.991 247.27C203.511 254.86 198.931 256.36 197.291 258.59Z",
    fill: "#FCC8A0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.82 264.13C178.55 260.25 176.67 256.39 178.87 252.4C179.35 251.53 171.43 243.1 192.85 245.65C194.36 245.83 195.57 239.96 191.96 238.01C189.38 236.62 176.53 238.27 176.48 238.27C180.75 237.35 191.2 234.81 194.86 234.81C195.58 234.81 195.99 232.45 196.02 231.63C196.06 230.56 191.24 228.81 189.78 228.57C186.89 228.1 184.48 227.51 181.75 228.09C181.3 228.19 178.24 228.81 174.29 229.72C172.58 228.15 172.79 227.08 170.42 227.29C165.01 227.77 153.85 233.1 153.09 233.81C146.94 239.58 142.82 248.87 136.04 254.47C134.2 255.29 117.3 262.66 117.3 262.66C116.16 269.81 126.29 286.78 128.98 288.28C135.52 282.14 138.17 279.6 145.73 275.87C147.93 274.78 152.13 275.31 156.57 274.12C164.59 271.96 174.03 268.49 176.81 264.13H176.82Z",
    fill: "#FCC8A0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M185.15 227.03C187.11 227.03 190.31 228.05 192.22 228.55C195.06 229.17 196.36 230.26 196.8 231.39C197.55 233.28 195.89 235.26 195.11 235.26C187.27 235.96 177.98 240.09 170.64 240.32C174.28 236.18 192.92 234.4 194.03 233.65C195.52 232.63 195.46 231.73 194.09 231.01C191.6 229.71 186.95 229.08 185.61 229.08C179.45 228.96 167.69 231.52 161.74 233.5C163.71 230.67 180.78 226.95 185.14 227.04L185.15 227.03ZM147.23 273.75C155.41 271.87 176.22 270.35 176.32 257.94C176.34 255.79 177.01 254.33 178.26 252.06L179.48 252.73C178.4 254.7 178.38 256.69 178.36 258.66C178.34 260.56 178.33 262.45 177.46 264.4C176.65 266.23 173.27 268.42 169.36 270.32C160.41 274.68 157.17 274.6 148.66 275.78C144.58 276.34 129.03 288.52 128.99 288.28C130.63 285.21 143.9 274.52 147.24 273.75H147.23Z",
    fill: "#F3925A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.061 134.77C82.061 134.77 81.811 155.47 74.671 167.07C69.631 182.43 105.941 196.72 114.891 182.87C118.151 177.82 117.251 173.37 118.051 172.18C118.841 170.99 111.001 160.02 82.061 134.78V134.77Z",
    fill: "#FCC8A0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.29 165.48C134.97 160.31 138.74 154.24 142.33 146.52C149.2 131.75 156.94 100.04 142.95 86.57C135.85 79.73 117.71 61.33 92.1997 82.89C83.8697 89.93 79.9197 100.26 79.1597 111.44C59.9197 112.43 68.1197 140.93 81.7097 134.92C89.3497 162.97 111.8 185.88 130.28 165.47L130.29 165.48Z",
    fill: "#FCC8A0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M131.159 137.59C132.519 141.74 130.549 143.5 129.509 144.14C127.759 145.21 128.559 146.34 130.099 145.93C132.419 145.3 135.419 143.47 133.539 137.31C131.569 130.81 130.349 126 134.639 119.7C135.139 118.47 126.509 123.47 131.149 137.6L131.159 137.59Z",
    fill: "#F3925A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.29 116.47C142.89 115.37 134.21 114.01 140.61 112.27C142.23 111.83 143.89 111.84 145 112.58C147.21 114.06 147.92 117.67 145.29 116.47Z",
    fill: "#262440"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.661 110.26C117.631 110 114.811 110.62 113.901 110.08C111.101 108.42 118.511 103.8 123.431 107.96C126.301 110.39 124.911 111.13 123.671 110.95C122.301 110.76 120.861 110.41 119.661 110.26Z",
    fill: "#262440"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.32 129.79C143.1 131.25 141.68 132.26 140.16 132.06C138.64 131.86 137.58 130.51 137.8 129.06C138.02 127.6 139.44 126.59 140.96 126.79C142.49 126.99 143.55 128.34 143.33 129.79H143.32Z",
    fill: "#262440"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.08 125.11C119.86 126.57 118.45 127.58 116.92 127.38C115.4 127.18 114.34 125.84 114.56 124.38C114.78 122.92 116.2 121.91 117.72 122.11C119.25 122.31 120.3 123.66 120.08 125.11Z",
    fill: "#262440"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M124.399 151.6C120.709 151.69 119.199 151.56 116.069 148.52C111.599 144.16 112.709 150.41 116.459 152.83C124.249 157.85 131.889 151.42 124.399 151.6Z",
    fill: "#262440"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.281 124.39C150.741 108.32 154.581 96.92 131.791 93.14C129.781 92.81 108.771 91.62 106.391 93.19C101.781 96.22 109.151 107.31 98.4809 111.2C91.4709 113.75 90.6009 125.15 88.7809 129.58C88.3109 130.72 84.5009 129.29 84.2209 122.16C83.2509 116.3 79.8809 111.42 75.3809 111.96C77.2209 101.18 75.4609 77.36 93.6209 75.56C102.391 67.14 118.551 65.84 132.231 70.67C145.071 75.17 145.151 81.92 156.611 84.61C152.401 105.59 160.301 95.49 149.281 124.4V124.39Z",
    fill: "#262440"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7605 117.46C71.3005 118.55 72.0305 126.88 75.3205 129.17C78.4205 131.33 71.3905 131.12 71.2605 124.7C71.0205 112.68 80.1205 117.06 77.7605 117.45V117.46Z",
    fill: "#F3925A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2191 157.94C98.1191 165.77 107.549 174.24 122.339 171.61C101.819 180.86 91.9291 159.88 92.2191 157.94Z",
    fill: "#F3925A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4098 280.25C60.0998 270.45 61.5298 243.81 63.0898 235.42C64.1998 245.02 64.2098 267.69 64.5798 279.45L60.4098 280.25Z",
    fill: "#295860"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M128.98 288.28C121.42 298.76 49.9601 335.46 28.3301 323.41C36.6001 324.71 55.6801 322.57 78.4401 313.54C101.81 304.27 128.78 288.09 128.98 288.28Z",
    fill: "#295860"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M117.31 262.67C113.9 265.26 62.7497 282.55 56.9297 281.08C60.0597 278.73 114.57 262.47 117.31 262.67Z",
    fill: "#295860"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.7 260.66C192.07 267.94 199.25 262.48 197.1 258.34C198.75 257.56 200.95 256.67 201.86 255.1C202.93 253.24 202.95 250.54 201.5 249.01C204.25 245.61 208.09 239.54 205 236.19C211.92 229.73 209.64 226.31 199.38 224.35C191.74 222.9 193.62 231.3 202.33 233.63L201.18 234.47C196.62 233.94 187.72 236.12 183.26 237C177.25 238.18 179.89 242.71 184.11 243.52C182.84 243.39 176.52 242.53 174.87 243.18C173.14 243.85 172.72 248.32 175.81 249.28C171.46 254.34 185 256.14 187.71 260.66H187.7Z",
    fill: "#FCC8A0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.45 209.66H206.49C207.12 209.66 207.19 210.17 206.65 210.8L199.65 218.95C199.11 219.58 198.15 220.09 197.52 220.09H192.48C191.85 220.09 191.78 219.58 192.32 218.95L199.32 210.8C199.86 210.17 200.82 209.66 201.44 209.66H201.45Z",
    fill: "#F3E7F2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.399 211.13C203.279 211.13 203.449 211.87 202.759 212.79C202.079 213.71 200.809 214.45 199.919 214.45C199.029 214.45 198.869 213.71 199.559 212.79C200.239 211.87 201.509 211.13 202.399 211.13Z",
    fill: "#213B3F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.851 215.13C199.731 215.13 199.901 215.87 199.211 216.79C198.531 217.71 197.261 218.45 196.371 218.45C195.481 218.45 195.321 217.71 196.011 216.79C196.691 215.87 197.961 215.13 198.851 215.13Z",
    fill: "#213B3F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M194.909 245.43C196.819 245.97 199.139 246.45 200.819 247.51C202.559 246.58 205.509 241.57 205.159 238.94C204.199 231.7 189.029 236.36 184.579 237.23C178.229 238.48 180.359 241.92 185.049 242.6C187.379 242.93 198.919 242.23 199.439 242.49C199.719 242.63 199.779 242.82 199.569 243.06C198.999 243.7 196.349 244.37 194.909 245.43ZM186.489 260.99C186.149 263.92 188.299 266.43 188.309 266.44C182.719 264.67 186.219 255.94 184.059 260.34C182.629 263.27 182.219 267.95 182.209 267.96C179.359 264.25 183.599 258.7 182.309 257.87C178.589 255.49 172.009 254.54 174.779 249.7C170.949 247.81 171.719 243.18 174.479 242.1C175.579 241.91 176.509 241.78 178.279 241.94C177.819 241.13 177.499 237.3 181.789 236.54L196.129 234.01L196.689 232.11C192.569 229.39 191.839 223.02 197.829 223.27C202.019 223.44 207.999 226.3 209.069 228.38C210.139 230.44 209.669 232.73 206.189 236.48C206.539 237.08 206.789 237.78 206.909 238.61C207.279 241.4 203.969 247.23 202.059 249.11C205.959 254.3 200.209 258.3 197.849 259.21C198.049 260.08 197.959 260.99 197.439 261.91C193.419 269.01 189.169 274.22 180.409 274.26C176.059 274.28 173.239 272.01 171.289 268.41L172.349 267.07C174.119 270.34 176.629 271.71 180.589 271.69C190.209 271.65 191.899 268.15 195.879 262.43C198.699 258.38 193.749 255.49 190.739 253.37C189.539 252.52 187.379 251.67 185.039 250.97C183.779 250.59 177.799 249.02 176.719 249.41C175.669 249.78 175.589 251.6 176.179 252.48C176.499 253.38 179.679 254.64 182.719 256.09C187.629 258.42 189.879 262.47 191.139 263.32C188.539 263.55 188.119 262.29 186.469 261L186.489 260.99ZM175.989 248.3C177.859 247.04 190.149 250.39 192.379 251.96C193.919 253.04 196.009 254.65 197.239 256.69C202.669 254.12 203.229 249.74 196.589 247.29C191.359 245.36 178.499 242.91 175.219 243.67C173.199 244.45 173.739 247.3 175.999 248.29L175.989 248.3ZM205.809 234.68C208.079 232.18 208.339 230.17 207.579 228.69C206.239 226.09 195.369 222.38 195.099 226.47C194.879 229.82 199.299 232.07 202.399 233.09C203.839 233.56 204.009 236.65 205.809 234.68Z",
    fill: "#F3925A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6699 508.88C88.7199 508.69 108.89 440.39 111.11 421.09C115.09 431.67 98.3899 493.38 94.5999 508.88H88.6699Z",
    fill: "#37417B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.781 450.47H574.601C600.411 450.47 608.901 448.03 589.561 458.62L497.431 505.81C490.641 508.01 476.601 509.25 463.161 508.79L222.261 505.28C178.781 503.79 211.921 496.48 225.651 493.94C264.651 486.71 390.051 450.49 429.791 450.49L429.781 450.47Z",
    fill: "#D6DAE6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.869 421.75H567.529V342.88H595.869V421.75Z",
    fill: "#091C39"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.8 455.83H468.01V376.97H508.8V455.83Z",
    fill: "#213B3F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.979 320.12C241.859 304.93 262.519 306.83 270.919 305.92L262.349 320.38L247.969 320.12H247.979Z",
    fill: "#295860"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.02 458.61C557.89 458.61 553.74 441.47 553.74 420.33C553.74 399.19 557.9 382.05 563.02 382.05H587.78V458.61H563.02Z",
    fill: "#213B3F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.049 505.19C451.459 505.19 443.689 481.4 443.689 452.04C443.689 422.68 451.459 398.89 461.049 398.89H489.299V505.19H461.049Z",
    fill: "#213B3F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.299 398.89C498.889 398.89 506.659 422.69 506.659 452.04C506.659 481.39 498.889 505.19 489.299 505.19C479.709 505.19 471.939 481.4 471.939 452.04C471.939 422.68 479.709 398.89 489.299 398.89Z",
    fill: "#37417B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M490.5 448.84C489.75 448.84 489.15 450.68 489.15 452.95C489.15 455.22 489.75 457.06 490.5 457.06C491.25 457.06 491.85 455.22 491.85 452.95C491.85 450.68 491.25 448.84 490.5 448.84Z",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 22.93
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.5 416.2C483.83 416.2 478.42 432.66 478.42 452.96C478.42 473.26 483.83 489.72 490.5 489.72C497.17 489.72 502.58 473.26 502.58 452.96C502.58 432.66 497.17 416.2 490.5 416.2Z",
    fill: "#F2F2F3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.67 420.66C484.18 420.66 479.73 435.12 479.73 452.95C479.73 470.78 484.18 485.24 489.67 485.24C495.16 485.24 499.61 470.78 499.61 452.95C499.61 435.12 495.16 420.66 489.67 420.66Z",
    fill: "#213B3F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.15 452.36C479.37 454.35 480.04 454.38 480.04 454.38L487.04 456.89L481.94 470.5C481.94 470.5 481.389 471.69 481.579 473.7C481.909 477.13 485.41 485.16 486.59 485.18C487.28 485.19 487.5 483.25 487.5 483.25L490.56 463.47L493.34 483.62C493.34 483.62 493.54 485.59 494.22 485.67C495.4 485.8 499.01 478.23 499.39 474.85C499.61 472.86 499.079 471.61 499.079 471.61L493.87 456.47C493.82 456.38 493.77 456.3 493.72 456.22L500.88 454.57C500.88 454.57 501.559 454.63 501.799 452.67C502.209 449.32 501 436.5 500.06 434.33C499.51 433.06 498.95 434.2 498.95 434.2L492.579 444.43C492.529 444.58 492.48 444.72 492.43 444.87C492.45 444.74 492.48 444.61 492.5 444.47L493.97 423.02C493.97 423.02 494.18 421.06 493.62 419.81C492.68 417.67 488.29 417.67 487.35 419.81C486.8 421.06 487 423.02 487 423.02L488.47 444.47C488.7 445.9 488.98 446.96 489.34 447.13H491.62C491.78 447.06 491.919 446.82 492.049 446.46C491.989 446.88 491.96 447.3 491.98 447.72L492.609 454.4C492.689 454.9 492.82 455.28 493 455.56C492.87 455.55 492.75 455.61 492.64 455.78L490.76 459.72C490.67 459.99 490.6 460.32 490.56 460.7C490.52 460.31 490.46 459.97 490.38 459.69L488.56 455.51C488.47 455.37 488.38 455.29 488.28 455.26L489 448.67C489.06 447.55 488.82 446.42 488.45 445.3L482.23 434.27C482.23 434.27 481.68 433.06 481.12 434.25C480.15 436.3 478.76 448.95 479.13 452.35L479.15 452.36Z",
    fill: "#F2F2F3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.501 443.38C488.691 443.38 487.211 447.86 487.211 453.38C487.211 458.9 488.681 463.38 490.501 463.38C492.321 463.38 493.791 458.9 493.791 453.38C493.791 447.86 492.321 443.38 490.501 443.38Z",
    fill: "#F7F2F3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.839 449.61C493.949 450.52 493.749 451.58 493.389 451.99C493.029 452.4 492.649 451.99 492.539 451.08C492.429 450.17 492.629 449.11 492.989 448.7C493.349 448.29 493.729 448.7 493.839 449.61ZM490.499 447.54C489.519 447.54 488.719 449.96 488.719 452.95C488.719 455.94 489.519 458.36 490.499 458.36C491.479 458.36 492.279 455.94 492.279 452.95C492.279 449.96 491.479 447.54 490.499 447.54ZM490.499 442C490.819 442 491.079 442.95 491.079 444.12C491.079 445.29 490.819 446.24 490.499 446.24C490.179 446.24 489.919 445.29 489.919 444.12C489.919 442.95 490.179 442 490.499 442ZM492.549 461.49C492.279 462.02 491.899 461.65 491.689 460.68C491.479 459.7 491.519 458.48 491.789 457.95C492.059 457.42 492.439 457.79 492.649 458.76C492.859 459.74 492.819 460.96 492.549 461.49ZM487.159 449.61C487.049 450.52 487.249 451.58 487.609 451.99C487.969 452.4 488.349 451.99 488.459 451.08C488.569 450.17 488.369 449.11 488.009 448.7C487.649 448.29 487.269 448.7 487.159 449.61ZM488.399 461.29C488.159 460.67 488.159 459.43 488.399 458.54C488.649 457.65 489.049 457.43 489.289 458.05C489.529 458.67 489.529 459.9 489.289 460.8C489.039 461.69 488.639 461.91 488.399 461.29Z",
    fill: "#213B3F"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.729 498.93C216.269 498.93 207.789 475.14 207.789 445.78C207.789 416.42 216.269 392.63 226.729 392.63H257.559C268.019 392.63 276.499 416.42 276.499 445.78C276.499 475.14 268.019 498.93 257.559 498.93H226.729Z",
    fill: "#213B3F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.31 328.8C219.76 335.5 202.71 361.15 200.37 371.68C196.88 387.4 192.05 437.74 197.68 455.56C199.51 461.36 201.12 465.67 206.71 465.23C232.28 463.21 402.82 467.35 444.87 471.29C455.53 472.29 470.5 477.04 471.8 462.07C472.51 453.92 476.78 382.31 495.27 385.69C505.06 387.48 508.85 404.9 506.21 440.06C506.5 443.91 506.65 447.92 506.65 452.05C506.65 453.32 506.63 454.59 506.61 455.84C507.31 456.17 508.2 456.18 509.2 455.75L571.98 429.81C574.52 428.87 576.07 426.99 576.63 424.17C577.88 417.23 582.61 364.44 590.9 368.64C598.13 372.3 595.23 405.92 593.84 414.86C593.84 414.86 599.48 391.87 599.76 380.16C600.04 368.45 598.77 361.26 598.07 356.89C597.36 352.52 595.81 335.31 595.11 332.07C594.4 328.83 592.01 314.44 587.78 308.09C573.2 286.22 572.03 263.16 545.89 252.88C533.76 248.1 513.5 243.85 500.05 242.28C457.18 237.29 361.59 241.21 323.73 264.74C296 281.98 280.82 301.17 256.37 315.81C247.75 320.97 238.94 323.33 230.31 328.81V328.8Z",
    fill: "#295860"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.991 361.19C296.951 372.02 330.071 367.3 396.011 361.99C397.351 361.83 392.891 377.54 392.891 377.54C363.411 387.27 260.841 394.49 221.221 375.83L224.981 361.19H224.991Z",
    fill: "#213B3F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.499 414.8C194.689 431.84 198.429 433.45 218.689 430.92C222.959 430.39 237.419 423.46 227.309 421.62C215.089 419.4 207.689 417.12 195.499 414.79V414.8Z",
    fill: "#F2F2F3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.659 337.81C210.609 344.97 201.779 361.01 200.369 371.68C209.669 374.92 221.879 378.03 229.999 379.73C244.349 382.73 245.389 343.29 220.669 337.82L220.659 337.81Z",
    fill: "#F2F2F3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.209 264.43C303.699 277.3 287.019 293.44 270.919 305.91C259.909 314.79 254.999 322.28 273.589 322.05C299.599 321.73 429.819 319.26 429.819 319.26C480.469 317.44 481.069 307.9 498.929 262.7C500.749 257.94 495.969 256.72 492.579 256.67C397.889 255.29 331.119 262.36 324.209 264.43Z",
    fill: "#213B3F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.8 272.74C502.13 278.9 487.44 330.12 502.39 325.64L568.11 305.16C577.43 291.66 569.97 274.79 559.03 264.98C555.88 262.98 546.76 259.55 529.31 256.12C516.53 253.61 511.83 256.53 504.8 272.74Z",
    fill: "#213B3F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.21 306.69L568.12 305.16L568.17 305.08L552.06 261.92C550.55 261.39 548.81 260.84 546.84 260.27L563.2 306.69H563.21Z",
    fill: "#37417B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.68 314.96L544.04 312.67L527.91 255.86C525.67 255.48 523.7 255.29 521.91 255.34L536.68 314.96Z",
    fill: "#37417B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.481 430.76C425.351 432.74 451.741 433.58 455.211 413.82C455.831 410.32 452.541 412.68 435.171 415.67C421.281 418.05 403.831 420.93 400.851 421.47C390.741 423.31 405.201 430.23 409.471 430.77L409.481 430.76Z",
    fill: "#F2F2F3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M502.981 325.51C513.071 364.21 512.531 397.44 512.531 436.85C512.451 440.33 514.471 440.99 517.241 440.46C523.441 439.29 567.601 420.41 567.721 420.36C572.651 417.52 579.481 382.13 581.031 375.78C587.921 347.6 586.391 324.81 567.551 305.34C563.211 292.36 557.631 273.42 551.571 261.76C548.181 255.23 525.071 252.17 518.481 253.51C512.791 254.67 507.561 262.03 503.731 270.96C502.891 272.92 496.221 286.91 497.531 300.3C498.231 307.47 501.311 318.16 502.981 325.53V325.51ZM501.821 325.79V325.77C496.661 302.95 492.541 293.96 502.631 270.47C506.601 261.23 512.111 253.58 518.241 252.33C526.351 250.68 549.051 253.78 553.101 262.29C557.561 271.65 567.771 302.27 568.531 304.53C588.361 324.76 588.421 350.57 582.181 376.05C580.891 381.34 573.061 420.9 568.091 421.48C565.941 422.4 523.631 440.45 517.451 441.62C510.731 442.89 511.251 437.36 511.331 436.77C511.331 395.57 512.261 366.26 501.821 325.78V325.79Z",
    fill: "#295860"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.369 319.67C574.889 319.67 576.119 322.47 576.119 325.93C576.119 329.39 574.889 332.19 573.369 332.19C571.849 332.19 570.619 329.39 570.619 325.93C570.619 322.47 571.849 319.67 573.369 319.67Z",
    fill: "#37417B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.4 334.31C544.92 334.31 546.15 337.11 546.15 340.57C546.15 344.03 544.92 346.83 543.4 346.83C541.88 346.83 540.65 344.03 540.65 340.57C540.65 337.11 541.88 334.31 543.4 334.31Z",
    fill: "#37417B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.51 324.54C570.89 324.43 573.56 324.3 575.1 323.72C575.79 323.46 575.5 323.04 575.74 322.72C578.38 319.38 583.01 329.57 571.82 330.22C568.02 331.03 569.38 324.86 570.51 324.54Z",
    fill: "#37417B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.801 256.64C493.601 244.65 511.481 241.73 522.811 246.22C504.721 243.45 494.671 256.82 494.651 256.86L487.801 256.64Z",
    fill: "#213B3F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.539 364.94C447.779 370.3 405.789 377.02 391.889 379.24C378.959 381.31 397.819 326.87 460.819 340.45C466.629 341.7 455.679 359.04 451.539 364.93V364.94Z",
    fill: "#F2F2F3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M541.04 313.34C541.04 313.34 556.02 327.11 557.05 337.11C560.63 371.74 555.19 396.21 548.37 429.44L547.2 429.34C553.99 396.23 559.44 371.81 555.87 337.3C554.87 327.66 540.2 314.17 540.15 314.13L541.04 313.35V313.34Z",
    fill: "#295860"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M449.32 338.75C453.33 333.8 466.77 318.06 467.18 313.31L469.53 312.34C469.09 317.44 456.7 333.39 452.24 338.98L449.32 338.75Z",
    fill: "#295860"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.53 339.19C540.91 339.08 543.58 338.95 545.12 338.37C545.81 338.11 545.52 337.69 545.76 337.37C548.4 334.03 553.03 344.22 541.84 344.87C538.04 345.68 539.4 339.51 540.53 339.19Z",
    fill: "#37417B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.499 304.89C508.049 311.24 505.819 318.46 510.299 323.17C513.909 326.96 544.629 330 548.579 316.23C550.509 309.49 549.719 305.37 546.699 303.35C542.899 300.81 523.709 298.72 519.479 299.22C515.299 299.71 511.889 301.3 510.499 304.89Z",
    fill: "#295860"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.13 345C448.45 345.09 447.77 348.31 444.46 352.99C441.14 357.68 435.17 363.84 434.11 365.17C426.79 374.36 470.54 344.31 451.14 345H451.13Z",
    fill: "#A2C2E7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M246.671 416.95C246.671 425.8 232.881 447.48 224.471 454.62C224.521 454.53 242.851 422.53 242.851 416.95C242.851 411.75 228.911 397.62 228.881 397.59L236.391 398.63C241.221 403.44 246.671 415.61 246.671 416.95Z",
    fill: "#A2C2E7"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M390.371 398.07C390.371 398.07 375.201 413.66 375.201 418.96C375.201 424.53 397.001 458.3 397.051 458.38C389.241 453.56 372.701 426.45 371.381 418.96C371.381 412.06 384.771 398.76 384.811 398.73L390.371 398.07Z",
    fill: "#A2C2E7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M211.58 390.96C269.37 404.21 345.21 401.99 416.56 390.06C404.58 403.29 242.31 415.46 211.58 390.96Z",
    fill: "#A2C2E7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M587.78 382.06C592.91 382.06 597.06 399.2 597.06 420.34C597.06 441.48 592.9 458.62 587.78 458.62C582.66 458.62 578.5 441.48 578.5 420.34C578.5 399.2 582.66 382.06 587.78 382.06Z",
    fill: "#37417B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.77 263.72C336.08 254.14 356.11 248.07 367.23 249.22C340.77 255.79 338.17 261.77 336.42 262.68L327.76 263.72H327.77Z",
    fill: "#213B3F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M509.689 322.46C514.039 327.03 545.089 328.46 549.599 310.94C550.149 333.75 511.709 329.73 509.689 322.46Z",
    fill: "#295860"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.911 424.23H334.121C335.501 424.23 336.641 425.36 336.641 426.75V446.46C336.641 447.84 335.511 448.98 334.121 448.98H277.911C276.531 448.98 275.391 447.85 275.391 446.46V426.75C275.391 425.37 276.521 424.23 277.911 424.23Z",
    fill: "#F3E7F2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M588.419 418.02C588.019 418.02 587.699 419.34 587.699 420.97C587.699 422.6 588.019 423.92 588.419 423.92C588.819 423.92 589.139 422.6 589.139 420.97C589.139 419.34 588.819 418.02 588.419 418.02Z",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 22.93
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.42 394.59C584.86 394.59 581.98 406.4 581.98 420.97C581.98 435.54 584.87 447.35 588.42 447.35C591.97 447.35 594.86 435.54 594.86 420.97C594.86 406.4 591.97 394.59 588.42 394.59Z",
    fill: "#F2F2F3"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M587.98 397.8C585.05 397.8 582.68 408.17 582.68 420.97C582.68 433.77 585.05 444.14 587.98 444.14C590.91 444.14 593.28 433.77 593.28 420.97C593.28 408.17 590.91 397.8 587.98 397.8Z",
    fill: "#213B3F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.369 420.54C582.479 421.97 582.849 421.99 582.849 421.99L586.579 423.79L583.859 433.56C583.859 433.56 583.569 434.41 583.669 435.86C583.849 438.32 585.719 444.08 586.339 444.09C586.709 444.09 586.829 442.7 586.829 442.7L588.459 428.51L589.949 442.97C589.949 442.97 590.049 444.38 590.419 444.44C591.049 444.53 592.969 439.11 593.179 436.67C593.299 435.24 593.009 434.34 593.009 434.34L590.229 423.48C590.199 423.42 590.179 423.36 590.149 423.3L593.969 422.12C593.969 422.12 594.329 422.16 594.459 420.75C594.679 418.35 594.029 409.15 593.529 407.59C593.239 406.68 592.939 407.5 592.939 407.5L589.539 414.84C589.509 414.94 589.489 415.05 589.459 415.16C589.469 415.07 589.479 414.97 589.499 414.87L590.279 399.48C590.279 399.48 590.389 398.07 590.089 397.18C589.589 395.65 587.249 395.65 586.739 397.18C586.439 398.08 586.549 399.48 586.549 399.48L587.329 414.87C587.449 415.89 587.599 416.66 587.799 416.78H589.019C589.099 416.73 589.179 416.56 589.249 416.3C589.219 416.6 589.199 416.9 589.209 417.21L589.549 422C589.589 422.36 589.659 422.63 589.759 422.84C589.689 422.84 589.629 422.88 589.569 422.99L588.569 425.82C588.519 426.01 588.489 426.25 588.459 426.53C588.439 426.25 588.409 426.01 588.359 425.81L587.389 422.81C587.339 422.71 587.289 422.65 587.239 422.63L587.629 417.9C587.659 417.09 587.529 416.29 587.339 415.48L584.019 407.56C584.019 407.56 583.729 406.69 583.429 407.55C582.909 409.02 582.169 418.1 582.369 420.54Z",
    fill: "#F2F2F3"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.42 414.1C587.45 414.1 586.67 417.31 586.67 421.27C586.67 425.23 587.45 428.44 588.42 428.44C589.39 428.44 590.17 425.23 590.17 421.27C590.17 417.31 589.39 414.1 588.42 414.1Z",
    fill: "#F7F2F3"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.199 418.56C590.259 419.21 590.149 419.97 589.959 420.27C589.769 420.56 589.559 420.27 589.509 419.62C589.449 418.97 589.559 418.21 589.749 417.91C589.939 417.62 590.149 417.91 590.199 418.56ZM588.419 417.08C587.899 417.08 587.469 418.82 587.469 420.96C587.469 423.1 587.899 424.84 588.419 424.84C588.939 424.84 589.369 423.1 589.369 420.96C589.369 418.82 588.939 417.08 588.419 417.08ZM588.419 413.1C588.589 413.1 588.729 413.78 588.729 414.62C588.729 415.46 588.589 416.14 588.419 416.14C588.249 416.14 588.109 415.46 588.109 414.62C588.109 413.78 588.249 413.1 588.419 413.1ZM589.519 427.09C589.379 427.47 589.169 427.21 589.059 426.51C588.949 425.81 588.969 424.93 589.109 424.55C589.249 424.17 589.459 424.43 589.569 425.13C589.679 425.83 589.659 426.71 589.519 427.09ZM586.639 418.56C586.579 419.21 586.689 419.97 586.879 420.27C587.069 420.56 587.279 420.27 587.329 419.62C587.389 418.97 587.279 418.21 587.089 417.91C586.899 417.62 586.689 417.91 586.639 418.56ZM587.299 426.95C587.169 426.5 587.169 425.62 587.299 424.98C587.429 424.34 587.639 424.18 587.769 424.63C587.899 425.08 587.899 425.96 587.769 426.6C587.639 427.24 587.429 427.4 587.299 426.95Z",
    fill: "#213B3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_3398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 686.39,
    height: 508.88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestdriveconfirm);
export default __webpack_public_path__ + "static/media/testdriveconfirm.8161863ae17236069025aaecf236cfd4.svg";
export { ForwardRef as ReactComponent };